<template>
  <div class="mt-4">
    <div class="mb-6 rounded-xl border border-blue-100 bg-blue-50 px-4 py-3">
      <div class="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
        <div>
          <p class="text-sm font-semibold text-slate-700">
            Administra solamente los productos que ya tienen ofertas configuradas, sin mezclar este submódulo con el catálogo completo.
          </p>
          <p class="text-xs text-slate-500 mt-1">
            Cada oferta sigue usando el mismo motor de promociones del producto, pero aquí se concentra el mantenimiento de lo que realmente está ofertado.
          </p>
        </div>

        <div class="grid gap-3 sm:grid-cols-2 xl:grid-cols-[180px_140px_auto] xl:items-end xl:min-w-fit">
          <label class="block w-full">
            <span class="block text-gray-600 font-semibold mb-1">Sucursales</span>
            <select
              v-model="idstore"
              @change="resetValuesAndGetData"
              class="bg-white border py-2 text-sm px-3 text-gray-600 cursor-pointer rounded-lg outline-none min-w-[180px] font-semibold w-full"
            >
              <option :value="dataStore.id" v-for="(dataStore, index) in dataStores" :key="index">
                {{ dataStore.razon_social }}
              </option>
            </select>
          </label>

          <label class="block w-full">
            <span class="block text-gray-600 font-semibold mb-1">Registros</span>
            <select
              v-model="limitRegister"
              class="bg-white border py-2 text-sm px-3 text-gray-600 cursor-pointer rounded-lg outline-none min-w-[140px] font-semibold w-full"
              @change="resetValuesAndGetData"
            >
              <option value="10">10 Registros</option>
              <option value="25">25 Registros</option>
              <option value="50">50 Registros</option>
              <option value="100">100 Registros</option>
            </select>
          </label>

          <div class="w-full xl:w-auto">
            <span class="block text-transparent font-semibold mb-1 select-none">Acción</span>
            <button
              class="w-full xl:w-auto bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-600"
              @click="openCreatePromotionModal"
            >
              Nueva oferta
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="rounded-lg overflow-hidden border">
      <div class="py-4 px-3 flex flex-wrap items-end gap-3">
        <label class="block w-full md:max-w-sm">
          <span class="block text-gray-600 font-semibold mb-1">Buscar producto</span>
          <input
            type="text"
            class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
            placeholder="Buscar por nombre, codigo de barra o tipo de producto..."
            v-model="search"
            @keydown.enter="resetValuesAndGetData"
          />
        </label>
      </div>

      <div class="w-full overflow-x-auto">
        <table class="table-auto w-full">
          <TableHead :headers="header" />
          <LoadingTables v-if="loading" :columns="7" />
          <tbody class="text-gray-500 text-left border-t-[1px]" v-else>
            <tr
              v-for="(register, index) in registers"
              :key="index"
              class="hover:bg-blue-500 transition-colors hover:text-white capitalize font-semibold odd:bg-white even:bg-slate-50"
              @click="selectRow($event)"
            >
              <td class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap bg-blue-50 text-blue-500">
                {{ register.codigo_de_barra }}
              </td>
              <td class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap">
                {{ register.nombre_producto }}
              </td>
              <td class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap">
                {{ register.tipoproducto }}
              </td>
              <td class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap">
                <span class="px-3 py-1 rounded-lg bg-blue-50 text-blue-600">
                  {{ register.stock }}
                </span>
              </td>
              <td class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap">
                <span class="px-3 py-1 rounded-lg bg-amber-50 text-amber-700">
                  {{ register.total_ofertas }} configurada{{ Number(register.total_ofertas) === 1 ? "" : "s" }}
                </span>
              </td>
              <td class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap">
                <span
                  class="px-3 py-1 rounded-lg text-sm"
                  :class="{
                    'bg-green-50 text-green-700': Number(register.ofertas_activas) > 0,
                    'bg-slate-100 text-slate-600': Number(register.ofertas_activas) <= 0,
                  }"
                >
                  {{ Number(register.ofertas_activas) > 0 ? `${register.ofertas_activas} activa${Number(register.ofertas_activas) === 1 ? '' : 's'}` : "sin activas" }}
                </span>
              </td>
              <td class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap text-right">
                <button
                  class="px-3 py-2 rounded-md text-sm font-semibold"
                  :class="promotionLoadingProductId === register.id
                    ? 'bg-slate-100 text-slate-400 cursor-wait'
                    : 'bg-blue-100 text-blue-600 hover:bg-blue-600 hover:text-white'"
                  :disabled="promotionLoadingProductId === register.id"
                  @click.stop="openPromotionModal(register)"
                >
                  {{ promotionLoadingProductId === register.id ? "Cargando..." : "Editar" }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <TablePagination :currentPage="currentPage" :total="totalPage" :next="next" :prev="prev" />
    </div>
  </div>

  <ProductPromotionModal
    v-if="statePromotionModal"
    :activeModal="activePromotionModal"
    :promotions="productPromotions"
    :productName="selectedProduct.name"
    :productBarCode="selectedProduct.barCode"
    :baseSalePrice="selectedProduct.salePrice"
    :productId="selectedProduct.id"
    :idStore="idstore"
    :closeOnSave="false"
    :saving="promotionSaving"
    :allowProductSelection="promotionModalMode === 'create'"
    :onProductSelected="handleModalProductSelection"
    @save="savePromotions"
  />
</template>

<script>
import { onBeforeMount, ref, watch } from "vue";
import { useRoute } from "vue-router";
import axios from "@/api";
import LoadingTables from "@/components/Loadings/LoadingTables";
import TableHead from "@/components/TablesComponents/TableHead";
import TablePagination from "@/components/TablesComponents/TablePagination.vue";
import ProductPromotionModal from "@/components/Store/Products/Main/ProductPromotionModal.vue";
import { errorActions, successAction, warningActions } from "@/alerts";
import { idLocalStore, idLocalUser } from "@/publicjs/localStorage";
import { selectRow } from "@/publicjs/selectRowTable";
import {
  fetchProductsWithOffers,
  fetchProductPromotions,
  syncProductPromotions,
} from "@/repository/Promotions/PromotionsRepository";
import {
  hydratePromotionsFromApi,
  normalizePromotionDrafts,
} from "@/utils/promotions";

export default {
  name: "MainProductOffers",
  components: {
    LoadingTables,
    ProductPromotionModal,
    TableHead,
    TablePagination,
  },
  setup() {
    const route = useRoute();
    const registers = ref([]);
    const loading = ref(true);
    const dataStores = ref([]);
    const currentPage = ref(1);
    const limitRegister = ref(10);
    const search = ref("");
    const totalPage = ref(0);
    const resgisterPaginate = ref(null);
    const idstore = ref(0);
    const statePromotionModal = ref(false);
    const promotionSaving = ref(false);
    const promotionLoadingProductId = ref(0);
    const promotionModalMode = ref("edit");
    const productPromotions = ref([]);
    const selectedProduct = ref({
      id: 0,
      name: "",
      barCode: "",
      salePrice: 0,
    });

    const getEmptySelectedProduct = () => ({
      id: 0,
      name: "",
      barCode: "",
      salePrice: 0,
    });

    const mapSelectedProduct = (product = {}) => ({
      id: Number(product.id || 0),
      name: product.nombre_producto || product.name || "",
      barCode: product.codigo_de_barra || product.barCode || "",
      salePrice: Number(product.precio_de_venta || product.salePrice || 0),
    });

    const header = [
      [
        { title: "cod. barra" },
        { title: "producto" },
        { title: "tipo" },
        { title: "stock" },
        { title: "ofertas" },
        { title: "activas" },
        { title: "Acciones" },
      ],
    ];

    const getData = async () => {
      loading.value = true;

      const response = await fetchProductsWithOffers({
        idStore: idstore.value,
        page: currentPage.value,
        perPage: limitRegister.value,
        search: search.value,
      })
        .catch((error) => {
          errorActions(error);
          return null;
        });

      if (!response) {
        loading.value = false;
        return;
      }

      const data = response;
      if ((data.data || []).length <= 0) {
        warningActions("No encontramos productos con ofertas configuradas para esos filtros.");
      }

      registers.value = data.data || [];
      resgisterPaginate.value = data;
      totalPage.value = data.last_page || 0;
      loading.value = false;
    };

    const getStores = async () => {
      const response = await axios.get("sucursales").catch((error) => {
        errorActions(error);
        return null;
      });

      if (!response) {
        return;
      }

      dataStores.value = response.data.data || [];
      if (dataStores.value.length > 0) {
        idstore.value = dataStores.value[0].id;
      }
    };

    const resetValuesAndGetData = async () => {
      currentPage.value = 1;
      await getData();
    };

    const activePromotionModal = (state = false) => {
      statePromotionModal.value = state === true;

      if (!statePromotionModal.value && !promotionSaving.value) {
        productPromotions.value = [];
        selectedProduct.value = getEmptySelectedProduct();
        promotionModalMode.value = "edit";
      }
    };

    const loadPromotionsForProduct = async (product) => {
      const normalizedProduct = mapSelectedProduct(product);
      selectedProduct.value = normalizedProduct;

      const promotions = await fetchProductPromotions(normalizedProduct.id, idstore.value);
      const hydratedPromotions = hydratePromotionsFromApi(promotions, {
        productId: normalizedProduct.id,
        productName: normalizedProduct.name,
      });

      productPromotions.value = hydratedPromotions;

      return {
        productId: normalizedProduct.id,
        productName: normalizedProduct.name,
        promotions: hydratedPromotions,
      };
    };

    const openPromotionModal = async (register) => {
      promotionModalMode.value = "edit";
      promotionLoadingProductId.value = register.id;

      try {
        await loadPromotionsForProduct(register);
        statePromotionModal.value = true;
      } catch (error) {
        errorActions(error?.response?.data?.detail || "No pudimos cargar las ofertas del producto.");
      } finally {
        promotionLoadingProductId.value = 0;
      }
    };

    const openCreatePromotionModal = () => {
      promotionModalMode.value = "create";
      selectedProduct.value = getEmptySelectedProduct();
      productPromotions.value = [];
      statePromotionModal.value = true;
    };

    const handleModalProductSelection = async (product) => {
      return await loadPromotionsForProduct(product);
    };

    const savePromotions = async (promotions) => {
      promotionSaving.value = true;

      try {
        const normalizedPromotions = normalizePromotionDrafts(promotions, {
          productId: selectedProduct.value.id,
          productName: selectedProduct.value.name,
        });

        const response = await syncProductPromotions({
          productId: selectedProduct.value.id,
          idStore: idstore.value,
          idUser: await idLocalUser(),
          promotions: normalizedPromotions,
        });

        productPromotions.value = hydratePromotionsFromApi(response?.data || [], {
          productId: selectedProduct.value.id,
          productName: selectedProduct.value.name,
        });
        statePromotionModal.value = false;
        await getData();

        successAction(
          "Ofertas actualizadas",
          `Las ofertas del producto <strong>${selectedProduct.value.name}</strong> fueron guardadas correctamente.`,
        );
      } catch (error) {
        errorActions(error?.response?.data?.detail || "No pudimos guardar las ofertas del producto.");
      } finally {
        promotionSaving.value = false;
      }
    };

    const next = async () => {
      totalPage.value = resgisterPaginate.value?.last_page || 0;
      if (currentPage.value <= totalPage.value - 1) {
        currentPage.value++;
      }
      await getData();
    };

    const prev = async () => {
      totalPage.value = resgisterPaginate.value?.last_page || 0;
      if (currentPage.value >= 2) {
        currentPage.value--;
      }
      await getData();
    };

    onBeforeMount(async () => {
      await getStores();
      idstore.value = Number(route.query.idstore || idstore.value || (await idLocalStore()));
      search.value = typeof route.query.search === "string" ? route.query.search : "";
      await getData();
    });

    watch(
      () => [route.query.search, route.query.idstore],
      async ([searchQuery, storeQuery]) => {
        const nextSearch = typeof searchQuery === "string" ? searchQuery : "";
        const nextStore = storeQuery ? Number(storeQuery) : idstore.value;
        const searchChanged = search.value !== nextSearch;
        const storeChanged = !!storeQuery && Number(idstore.value) !== nextStore;

        if (!searchChanged && !storeChanged) {
          return;
        }

        search.value = nextSearch;
        if (storeQuery) {
          idstore.value = nextStore;
        }

        currentPage.value = 1;
        await getData();
      },
    );

    return {
      activePromotionModal,
      currentPage,
      dataStores,
      getData,
      header,
      handleModalProductSelection,
      idstore,
      limitRegister,
      loading,
      next,
      openCreatePromotionModal,
      openPromotionModal,
      prev,
      promotionModalMode,
      productPromotions,
      promotionLoadingProductId,
      promotionSaving,
      registers,
      resetValuesAndGetData,
      savePromotions,
      search,
      selectRow,
      selectedProduct,
      statePromotionModal,
      totalPage,
    };
  },
};
</script>